import actions from 'actions';

const initialState = {
  loading: false,
  errorMessage: '',
  trials: [],
};

function trials(state = initialState, action) {
  switch (action.type) {
    case actions.trials.RECEIVE_TRIAL: {
      const trials = [];
      let found = false;
      state.trials.forEach((trial) => {
        if (trial._id === action.trial._id) {
          trial = Object.assign({}, trial, action.trial);
          found = true;
        }
        trials.push(trial);
      });
      if (!found) trials.push(action.trial);
      return Object.assign({}, state, { loading: false, errorMessage: '', trials });
    }
    default:
      return state;
  }
}

export default trials;
